<template>
  <div class="v2-style-bottom" @click="handleClick">
    <div
      class="menu-box"
      :style="{
        height: $h_Ratio(menuStyle.height, $store) + 'px',
        minWidth: $w_Ratio(menuStyle.width, $store) + 'px',
      }"
      :class="{ 'menu-down': !isOpenBottomMenu }"
    >
      <img class="bottom-bg" src="@/assets/img/style1/bottom_menu_bg.png" />

      <div
        class="menu-list"
        :style="{
          top: $h_Ratio(-50, $store) + '%',
        }"
      >
        <div
          class="menu-item"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <img :src="item.IconPath" alt="" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
    <div class="toggle-open-btn" :style="getToggleOpenBtn()" @click="toggleOpen">
      <i :class="isOpenBottomMenu ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'V2StyleBottom',
  components: {},
  props: {
    Configuration: Object,
    SceneryList: Array,
  },
  data() {
    return {
      isOpenBottomMenu: true,
      style: {
        // height: 100,
      },
      menuStyle: {
        height: 76,
        width: 700,
      },
      menuItemStyle: {},
      backgroundDefault: null,
    };
  },
  watch: {
    SceneryList: {
      deep: true,
      handler: function (newVal) {
        this.setMenuShowLength(newVal);
      },
    },
  },
  created() {
    this.setMenuShowLength(this.SceneryList);
    if (this.Configuration.propertyData.menuStyle) {
      this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    }
    this.backgroundDefault = this.$store.state.ProjectInfo.Background;
  },
  mounted() {
    this.SceneryList.sort((a, b) => {
      return a.sceneSortIndex - b.sceneSortIndex;
    });
  },
  methods: {
    ...mapMutations(['set_CurrentScene', 'set_ProjectBackground', 'set_CurrentConfigration']),
    setMenuShowLength(SceneryList) {
      if (SceneryList.length > 4) {
        this.menuStyle.width = 700 + (SceneryList.length - 4) * 95;
      }
      if (this.Configuration.propertyData.menuStyle) {
        this.$store.commit('set_ProjectStylePropertyData', {
          key: 'menuStyle',
          value: this.$_.cloneDeep(this.menuStyle),
        });
      }
    },
    toggleOpen() {
      this.isOpenBottomMenu = !this.isOpenBottomMenu;
    },
    handleSwitchScene(item) {
      this.set_CurrentScene(item.id);
      this.isShow = false;
      if (item.isChangeBk === true) {
        if (item.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          if (
            backgroundDefault == null ||
            backgroundDefault == 'null' ||
            backgroundDefault == undefined ||
            backgroundDefault == 'undefined'
          ) {
            this.set_ProjectBackground(this.backgroundDefault);
            this.set_CurrentConfigration(this.backgroundDefault);
          } else {
            this.set_ProjectBackground(backgroundDefault);
            this.set_CurrentConfigration(backgroundDefault);
          }
        } else {
          this.set_ProjectBackground(item.Background);
          this.set_CurrentConfigration(item.Background);
        }
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        if (
          backgroundDefault == null ||
          backgroundDefault == 'null' ||
          backgroundDefault == undefined ||
          backgroundDefault == 'undefined'
        ) {
          this.set_ProjectBackground(this.backgroundDefault);
          this.set_CurrentConfigration(this.backgroundDefault);
        } else {
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        }
      }
      // let name = this.$store.state.ProjectInfo.Background.componentName;
      // let map = {
      //   componentTitle: '地图背景',
      //   componentName: 'GisMapBackground',
      //   componentOverViewImg: './img/backgrounds/MapBackground.png',
      //   id: 'GisMapBackground',
      //   style: {
      //     backgroundColor: '#19242D',
      //   },
      //   propertyData: {
      //     mapBasicSetting: {
      //       value: {
      //         coordinate: {
      //           lng: '116.39156',
      //           lat: '39.90714',
      //         },
      //         zoom: 15,
      //         is3dMap: false,
      //       },
      //       propertyComponentName: 'mapBasicSetting',
      //       lable: '地图基本设置',
      //     },
      //     mapType: {
      //       value: {
      //         type: '2',
      //       },
      //       propertyComponentName: 'mapType',
      //       lable: '地图类型',
      //     },
      //     mapStyle: {
      //       value: {
      //         checkedId: 0,
      //         plan: {
      //           plancode: '575d2a1a8d57786ac4f8373f98808cef',
      //         },
      //       },
      //       propertyComponentName: 'mapStyle',
      //       lable: '个性化样式',
      //     },
      //   },
      // };
      // if (this.$store.state.ProjectInfo.CurrentScene?.isChangeBk) {
      //   if (name != 'GisMapBackground') {
      //     // 设置背景为地图
      //     this.set_ProjectBackground(map);
      //     this.set_CurrentConfigration(map);
      //   }
      // } else {
      //   if (name == 'GisMapBackground') {
      //     // 设置背景为原来保存的
      //     let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
      //     if (
      //       backgroundDefault == null ||
      //       backgroundDefault == 'null' ||
      //       backgroundDefault == undefined ||
      //       backgroundDefault == 'undefined'
      //     ) {
      //       this.set_ProjectBackground(this.backgroundDefault);
      //       this.set_CurrentConfigration(this.backgroundDefault);
      //     } else {
      //       this.set_ProjectBackground(backgroundDefault);
      //       this.set_CurrentConfigration(backgroundDefault);
      //     }
      //   }
      // }
    },
    getMenuStyle() {
      return {
        height: this.$h_Ratio(this.menuStyle.height, this.$store) + 'px',
        minWidth: this.$w_Ratio(this.menuStyle.width, this.$store) + 'px',
      };
    },
    getMenuItemStyle() {
      return {
        height: this.$w_Ratio(90, this.$store) + 'px',
        width: this.$w_Ratio(80, this.$store) + 'px',
        fontSize: '12px',
        margin: `0 ${this.$w_Ratio(15, this.$store)}px`,
      };
    },
    getToggleOpenBtn() {
      return {
        height: this.$h_Ratio(13, this.$store) + 'px',
        width: this.$w_Ratio(150, this.$store) + 'px',
        fontSize: this.$w_Ratio(14, this.$store) + 'px',
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,

      SceneryList: state => state.ProjectInfo.SceneryList,
    }),
    newSceneryList() {
      return this.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v2-style-bottom {
  z-index: 99;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  transition: all 0.3s linear;
  color: white;
  background-color: rgb(179, 200, 245);

  .menu-box {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    transition: transform 0.3s linear;

    .bottom-bg {
      width: 100%;
      height: 90%;
      position: absolute;
      bottom: 0;
    }

    .menu-list {
      position: absolute;
      display: flex;
      top: -40%;
      left: 50%;
      transform: translateX(-50%);
      align-items: flex-end;
      justify-content: space-around;
      // width: 100%;
      height: 100%;

      .menu-item {
        cursor: pointer;
        flex-shrink: 0;
        // background-color: #4a57ce;
        transition: all 0.3s ease-out;

        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        .menu-item-icon-name {
          text-align: center;

          white-space: nowrap;
        }

        .menu-item-icon-ct {
          width: 100%;
          // height: 66%;
          transition: all 0.3s ease-out;
          margin-bottom: 2px;

          img {
            width: 100%;
            height: 100%;
          }

          opacity: 0.8;
        }

        .active {
          width: 110%;
          // height: 78%;
          opacity: 1;
        }

        &:hover .menu-item-icon-ct {
          width: 110%;
          // height: 78%;
        }
      }
    }
  }

  .menu-down {
    transform: translate(-50%, 200%);
  }

  .toggle-open-btn {
    cursor: pointer;
    width: 150px;
    height: 13px;
    font-size: 14px;
    background-color: #212631;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-weight: 700;

    &:hover {
      color: rgb(35, 130, 255);
    }
  }
}
</style>
